module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA1.60b83cb5.jpg";